import {
    BrowserRouter,
  } from 'react-router-dom';
  
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import '../src/css/global.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <App/>
    </BrowserRouter>
);
